const getters = {
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  routers: state => state.permission.routers,
  userid: state => state.user.uid,
  usertoken: state => state.user.token,
  permission: state => state.user.permission
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js